<div
    class="lead-from styled-scrolled"
    [formGroup]="leadForm">
    <div class="lead-from-header">
        <span>{{ formTitle }}</span>
    </div>
    <div class="lead-from-body">
        <div class="lead-form-row">
            <div class="lead-form-input-holder">
                <label class="padded-top-gray-label">Customer First Name* :</label>
                <input
                    type="text"
                    class="normal-text-input"
                    placeholder="Enter first name"
                    formControlName="firstname"
                    [ngClass]="{ 'normal-text-input--invalid': fieldIsValid('firstname') }" />
            </div>
            <div class="lead-form-input-holder">
                <label class="padded-top-gray-label">Customer Second Name* :</label>
                <input
                    type="text"
                    class="normal-text-input"
                    placeholder="Enter second name"
                    formControlName="surname"
                    [ngClass]="{ 'normal-text-input--invalid': fieldIsValid('surname') }" />
            </div>
        </div>
        <div class="lead-form-row">
            <div class="lead-form-input-holder">
                <label class="padded-top-gray-label">Customer Phone Number* :</label>
                <ys-phone-input formControlName="phone"></ys-phone-input>
            </div>
            <div class="lead-form-input-holder">
                <label class="padded-top-gray-label">Customer Email* :</label>
                <input
                    type="text"
                    class="normal-text-input"
                    placeholder="Enter email"
                    formControlName="email"
                    [ngClass]="{ 'normal-text-input--invalid': fieldIsValid('email') }" />
            </div>
        </div>
        <div class="lead-form-row">
            <div class="lead-form-input-holder">
                <label class="padded-top-gray-label">Customer Type:</label>
                <ng-select
                    formControlName="customerType"
                    [clearable]="false"
                    [clearOnBackspace]="true"
                    placeholder="Select Customer Type">
                    <ng-option
                        *ngFor="let customerType of customerTypes"
                        [value]="customerType.id">
                        {{ customerType.name }}
                    </ng-option>
                </ng-select>
            </div>
            <div class="lead-form-input-holder">
                <label class="padded-top-gray-label"
                    >Company <span *ngIf="leadForm.controls.company.hasValidator(Validators.required)">*</span> :</label
                >
                <input
                    type="text"
                    formControlName="company"
                    class="normal-text-input"
                    placeholder="Enter company"
                    [ngClass]="{ 'normal-text-input--invalid': fieldIsValid('company') }" />
            </div>
        </div>
        <div class="lead-form-row">
            <div class="lead-form-input-holder">
                <label class="padded-top-gray-label">Position:</label>
                <input
                    type="text"
                    formControlName="position"
                    class="normal-text-input"
                    placeholder="Enter position"
                    [ngClass]="{ 'normal-text-input--invalid': fieldIsValid('position') }" />
            </div>
            <div class="lead-form-input-holder">
                <label class="padded-top-gray-label">Country:</label>
                <input
                    type="text"
                    formControlName="country"
                    class="normal-text-input"
                    placeholder="Enter country"
                    [ngClass]="{ 'normal-text-input--invalid': fieldIsValid('country') }" />
            </div>
        </div>
        <div class="lead-form-row">
            <div class="lead-form-input-holder">
                <label class="padded-top-gray-label">Address Line:</label>
                <input
                    type="text"
                    formControlName="address"
                    class="normal-text-input"
                    placeholder="Enter address"
                    [ngClass]="{ 'normal-text-input--invalid': fieldIsValid('address') }" />
            </div>
            <div class="lead-form-input-holder">
                <label class="padded-top-gray-label">Town/City:</label>
                <input
                    type="text"
                    formControlName="city"
                    class="normal-text-input"
                    placeholder="Enter town/city"
                    [ngClass]="{ 'normal-text-input--invalid': fieldIsValid('city') }" />
            </div>
        </div>
        <div class="lead-form-row">
            <div class="lead-form-input-holder">
                <label class="padded-top-gray-label">Postcode:</label>
                <input
                    type="text"
                    formControlName="postcode"
                    class="normal-text-input"
                    placeholder="Enter postcode"
                    [ngClass]="{ 'normal-text-input--invalid': fieldIsValid('postcode') }" />
            </div>
            <div class="lead-form-input-holder">
                <label class="padded-top-gray-label">Lead Type:</label>
                <ng-select
                    formControlName="leadType"
                    [clearable]="false"
                    [searchable]="false"
                    placeholder="Select Lead Type">
                    <ng-option [value]="0"> Cold </ng-option>
                    <ng-option [value]="1"> Warm </ng-option>
                </ng-select>
            </div>
        </div>
        <div
            *ngIf="withAction"
            class="lead-form-action-cont">
            <div class="lead-action-top">
                <div class="lead-action-togle-holder">
                    <a
                        (click)="leadForm.patchValue({ isAction: !leadForm.controls.isAction.value })"
                        class="me-2 pt-1">
                        <i
                            class="toggle fa"
                            [ngClass]="{
                                'fa-toggle-on text-success': leadForm.controls.isAction.value,
                                'fa-toggle-off': !leadForm.controls.isAction.value
                            }"></i>
                        Add action
                    </a>
                </div>
                <div
                    *ngIf="leadForm.controls.isAction.value && actionTypes.length"
                    class="lead-action-type-selector-holder"
                    formGroupName="action">
                    <ng-select
                        style="min-width: 218px"
                        placeholder="Action type"
                        [clearable]="false"
                        [searchable]="false"
                        formControlName="actionType">
                        <ng-option
                            [value]="actionType.id"
                            *ngFor="let actionType of actionTypes">
                            {{ actionType.name }}
                        </ng-option>
                    </ng-select>
                </div>
            </div>
            <div
                formGroupName="action"
                *ngIf="leadForm.controls.isAction.value"
                class="lead-action-type-text-holder">
                <textarea
                    class="textarea-styled"
                    rows="4"
                    placeholder="Action"
                    formControlName="text"></textarea>
            </div>
        </div>
        <div class="lead-form-buttons-holder lead-form-row">
            <button
                class="btn-styled--secondary"
                (click)="close()">
                Cancel
            </button>
            <button
                class="btn-styled"
                [disabled]="this.leadForm.invalid"
                (click)="saveLead()">
                Save
            </button>
        </div>
    </div>
</div>
